import { LayoutSpaceVertical } from 'breeze-intelligence-kit';
import { useSmartProperties } from './useSmartProperties/useSmartProperties';
import { SmartPropertiesPanelEmpty } from '../SmartPropertiesEmpty';
import { BasePanel } from '../../Panel/BasePanel';
import { PanelLoading } from '../../Panel/PanelLoading';
import { SmartFillPanelUsage } from '../SmartFillPanelUsage';
import { UsageAlert } from '../../Usage/UsageAlert';
import { SmartFillPanelHeader } from '../SmartFillPanelHeader';
import { SmartFillPropertySelect } from '../SmartFillPropertySelect';
import { SmartPropertiesError } from '../SmartPropertiesError';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SmartPropertiesPanelBody() {
  const {
    properties,
    selectedProperties,
    onSelect,
    isLoading
  } = useSmartProperties();
  const {
    isError,
    errorId,
    isErrorCredits,
    onRetry
  } = useSmartProperties();
  const propertiesCount = properties.length;
  const selectedPropertiesCount = selectedProperties.length;
  return /*#__PURE__*/_jsx(PanelLoading, {
    isLoading: isLoading,
    children: /*#__PURE__*/_jsx(SmartPropertiesError, {
      errorId: errorId !== null && errorId !== void 0 ? errorId : undefined,
      isError: isError,
      isErrorCredits: isErrorCredits,
      onRetry: onRetry,
      children: /*#__PURE__*/_jsx(SmartPropertiesPanelEmpty, {
        propertiesCount: propertiesCount,
        children: /*#__PURE__*/_jsx(BasePanel.Body, {
          inlineSize: "100%",
          children: /*#__PURE__*/_jsx(BasePanel.Content, {
            paddingBlockStart: "space",
            children: /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
              inlineSize: "100%",
              children: [/*#__PURE__*/_jsx(UsageAlert, {
                action: "SMART_PROPERTY_RUN",
                numberOfOperations: selectedPropertiesCount
              }), /*#__PURE__*/_jsx(SmartFillPanelHeader, {
                count: 1
              }), /*#__PURE__*/_jsx(SmartFillPanelUsage, {
                numberOfOperations: selectedPropertiesCount
              }), /*#__PURE__*/_jsx(SmartFillPropertySelect, {
                onChange: onSelect,
                properties: properties,
                selectedProperties: selectedProperties
              })]
            })
          })
        })
      })
    })
  });
}